import { render, staticRenderFns } from "./HomePageSlider.vue?vue&type=template&id=4d9006d7&scoped=true&"
import script from "./HomePageSlider.vue?vue&type=script&lang=js&"
export * from "./HomePageSlider.vue?vue&type=script&lang=js&"
import style0 from "./HomePageSlider.vue?vue&type=style&index=0&id=4d9006d7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d9006d7",
  null
  
)

export default component.exports